import clsx from 'clsx';
import {
  Heading,
  type HeadingVariant,
  Paragraph,
  type ParagraphVariant,
} from '@hungryroot/ui-kit';
import styles from './ShimmerText.module.css';

const HEADING_VARIANTS: Set<string> = new Set<HeadingVariant>([
  'Hero',
  'HeroAlt',
  'H1',
  'H1Alt',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'H7',
]);

export type ShimmerTextVariant = HeadingVariant | ParagraphVariant;

export type ShimmerTextColor = 'primary' | 'secondary';

interface Props {
  text: string;
  variant?: ShimmerTextVariant;
  color?: ShimmerTextColor;
  className?: string;
  testid?: string;
}

export function ShimmerText({
  text,
  variant = 'body',
  color = 'primary',
  className,
  testid,
}: Props) {
  const shimmerClass = clsx(
    styles.shimmer,
    color === 'secondary' && styles.secondary,
    className
  );

  if (HEADING_VARIANTS.has(variant)) {
    return (
      <Heading
        variant={variant as HeadingVariant}
        as="span"
        testid={testid}
        className={shimmerClass}
      >
        {text}
      </Heading>
    );
  }

  return (
    <Paragraph
      variant={variant as ParagraphVariant}
      as="span"
      testid={testid}
      className={shimmerClass}
    >
      {text}
    </Paragraph>
  );
}
